var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_7);}.cls-2{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_7",
    cx: 332,
    cy: 210.33,
    r: 305.23,
    gradientTransform: "translate(-288.4 312.82) rotate(-38.74) scale(1 0.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9d27a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f8c871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f5ad58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ef8130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ef7e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#f04c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ed4a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d43e79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ca398e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#8d3cc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#304df0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Instagram-2",
    "data-name": "Instagram",
    className: "cls-2",
    d: "M384.5,53c14.8,0,16.66.06,22.47.33a39.85,39.85,0,0,1,13.23,2.53A27.92,27.92,0,0,1,436.14,71.8,39.85,39.85,0,0,1,438.67,85c.27,5.81.33,7.67.33,22.47s-.06,16.66-.33,22.47a39.85,39.85,0,0,1-2.53,13.23,27.92,27.92,0,0,1-15.94,15.94A39.85,39.85,0,0,1,407,161.67c-5.81.27-7.67.33-22.47.33s-16.66-.06-22.47-.33a39.85,39.85,0,0,1-13.23-2.53,27.92,27.92,0,0,1-15.94-15.94A39.85,39.85,0,0,1,330.33,130c-.27-5.81-.33-7.67-.33-22.47s.06-16.66.33-22.47a39.85,39.85,0,0,1,2.53-13.23A27.92,27.92,0,0,1,348.8,55.86,39.85,39.85,0,0,1,362,53.33C367.84,53.06,369.7,53,384.5,53Zm22,10.14c-5.74-.26-7.47-.32-22-.32s-16.28.06-22,.32A30.26,30.26,0,0,0,352.36,65,18.07,18.07,0,0,0,342,75.36a30.26,30.26,0,0,0-1.87,10.12c-.26,5.74-.32,7.47-.32,22s.06,16.28.32,22A30.26,30.26,0,0,0,342,139.64,18.07,18.07,0,0,0,352.36,150a30.26,30.26,0,0,0,10.12,1.87c5.74.26,7.47.32,22,.32s16.28-.06,22-.32A30.26,30.26,0,0,0,416.64,150,18.07,18.07,0,0,0,427,139.64a30.26,30.26,0,0,0,1.87-10.12c.26-5.74.32-7.47.32-22s-.06-16.28-.32-22A30.26,30.26,0,0,0,427,75.36,18.07,18.07,0,0,0,416.64,65,30.26,30.26,0,0,0,406.52,63.14Zm-22,62.53a18.17,18.17,0,1,0-18.17-18.17A18.18,18.18,0,0,0,384.5,125.67Zm0-46.16a28,28,0,1,1-28,28A28,28,0,0,1,384.5,79.51Zm35.63-1.1a6.54,6.54,0,1,1-6.54-6.54A6.54,6.54,0,0,1,420.13,78.41Z",
    transform: "translate(-277)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.994f0eac138114b277b9a363603d7eb2.svg";
export { ForwardRef as ReactComponent };